import * as React from "react";
import Modal from "./../../../shared/dialog";
import "./index.scss";
import { ButtonStyled } from "../../homes/containers/common-styled";

const index = (props) => {
  const { isGourmet, isBookingCity, isMedical, pageColor } = props;
  const text = isBookingCity ? "MY-Booking" : "CiPPo";

  const renderContent = () => {
    if (isBookingCity) {
      if (isGourmet) {
        return (
          <pre>
            {`予約履歴は
  ${text}アプリからご予約の方は
  アプリ下「予約一覧」の「グルメ予約」
  にも表示されます。`}
          </pre>
        );
      }

      if (isMedical) {
        return (
          <pre>
            {`予約履歴は
  ${text}アプリからご予約の方は
  アプリ下「予約一覧」の「クリニック予約
  にも表示されます。`}
          </pre>
        );
      }
    }

    return (
      <pre>
        {`予約履歴は
  ${text}アプリからご予約の方は
  アプリ下「予約一覧」の「美容予約」
  にも表示されます。`}
      </pre>
    );
  };
  return (
    <Modal
      className={"guide-modal"}
      title={""}
      isShow={true}
      closeByEscKey={false}
      showCloseButton={false}
      onCloseRequest={() => props.onClose()}
      closeOnOverlayClick={false}
    >
      {renderContent()}

      <div className="guide-modal__btn-area">
        <ButtonStyled
          className="btn btn-sm px-3 py-2 w-100 rounded"
          $color={pageColor}
          $isBg
          onClick={() => props.onClose()}
          style={{
            color: "#fff",
          }}
        >
          OK
        </ButtonStyled>
      </div>
    </Modal>
  );
};

export default index;
